import { API_AUTH } from "./common";

const ChiTietCuaHangApi = {
  chiTietCuaHangHienTai: () =>
    API_AUTH.get(`quan-ly-cua-hang/cua-hang-hien-tai`, {}),

  chiTietCuaHang: () =>
    API_AUTH.get(
      `quan-ly-cua-hang/chi-tiet-cua-hang-hopdong-thuchi-vonlai`,
      {},
    ),
  phanQuyenChiTietCuaHang: () =>
    API_AUTH.get(
      `quan-ly-cua-hang/phan-quyen-chi-tiet-cua-hang-hopdong-thuchi-vonlai`,
      {},
    ),
};

export default ChiTietCuaHangApi;
